require('./Resources/js/angular/module');
require('./Resources/js/angular/controllers/DownloadModalCtrl');
require('./Resources/js/angular/controllers/DownloadQueueCtrl');
require('./Resources/js/angular/controllers/DownloadQueueModalCtrl');
require('./Resources/js/angular/directives/downloadFrame');
require('./Resources/js/angular/directives/medialist');
require('./Resources/js/angular/services/Audition');
require('./Resources/js/angular/services/Download');
require('./Resources/js/angular/services/DownloadModal');
require('./Resources/js/angular/services/DownloadQueueModal');


// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/index.js